import React, { createContext, useContext } from 'react';
const EnforcedColorSchemeContext = createContext(undefined);
export const useEnforcedColorScheme = () => useContext(EnforcedColorSchemeContext);
export const EnforcedColorSchemeProvider = ({ colorScheme, children }) => (<EnforcedColorSchemeContext.Provider value={colorScheme}>
    {children}
  </EnforcedColorSchemeContext.Provider>);
